export enum RetailWarcraftTalentTreeNodeType {
  Single = 'single',
  Choice = 'choice',
  SubTreeChoice = 'subtree',
}

export enum RetailWarcraftTalentTreeType {
  ClassTree = 'class',
  SpecTree = 'spec',
  HeroTree = 'hero',
}

export enum RetailWarcraftTalentTreeEntryType {
  Active = 'active',
  Passive = 'passive',
}

export type RetailWarcraftTalentTreeEntry = {
  id: number;
  definitionId: number;
  type: RetailWarcraftTalentTreeEntryType;
  name: string;
  spellId: number;
  icon: string;
  heroTreeId?: number;
};

export type RetailWarcraftTalentTreeNode = {
  nodeId: number;
  type: RetailWarcraftTalentTreeNodeType;
  posX: number;
  maxRanks: number;
  childNodes: number[];
  row: number;
  treeType: RetailWarcraftTalentTreeType;
  abilities: RetailWarcraftTalentTreeEntry[];
  heroTreeId?: number;
};

export type LegacyRetailWarcraftTalentTreeNode = Omit<
  RetailWarcraftTalentTreeNode,
  'treeType'
> & {
  isClassTreeNode: boolean;
  isSpecTreeNode: boolean;
};

export type RetailWarcraftTalentTreeHeatMapPercent = {
  values: number[];
};

export type RetailWarcraftTalentTreeBuildNode = {
  node: RetailWarcraftTalentTreeNode;
  entry?: RetailWarcraftTalentTreeEntry | null;
  pointsInvested: number;
  heatMapPercent?: RetailWarcraftTalentTreeHeatMapPercent | null;
};

export type DehydratedRetailWarcraftTalentTreeChangeSet = {
  className: string;
  specName: string;
  changeSetId: number;
};

export type DehydratedRetailWarcraftTalentTreeNode = [
  number,
  number | undefined
];
export type DehydratedRetailWarcraftTalentBuild = {
  changeSet: DehydratedRetailWarcraftTalentTreeChangeSet;
  selectedNodes: DehydratedRetailWarcraftTalentTreeNode[];
  heroSpecId: number | null;
};

type TreeNode = RetailWarcraftTalentTreeBuildNode;
type TreeRow = TreeNode[];
export type RetailWarcraftTalentTree = TreeRow[];

export type HydratedRetailWarcraftTalentBuild = {
  classTree: RetailTalentTreeFullEntry;
  specTree: RetailTalentTreeFullEntry;
  heroTree: RetailTalentTreeFullEntry;
  spellModifierId: number;
};
export type RetailTalentTreeFullEntry = {
  tree: RetailWarcraftTalentTree;
  iconClassName: string;
  artwork: string;
  heroTree: RetailWarcraftHeroTreeBlueprint | null;
};

export type RetailWarcraftTalentTreeBlueprint = {
  classIcon: string;
  classBackgroundUrl: string;
  specIcon: string;
  specBackgroundUrl: string;
  heroTrees?: RetailWarcraftHeroTreeBlueprint[];
  labels: {
    spec: string;
    class: string;
    heroTreeTitle: string;
    showMore: string;
    showLess: string;
    talents: string;
    export: string;
    edit: string;
    heatmapTitle: string;
    heatmapSubtitle: string;
    heatmapDisclaimer: string;
    outdatedRevisionTitle: string;
    outdatedRevisionSubtitle: string;
    close: string;
  };
  changeSet: {
    allNodes: (
      | RetailWarcraftTalentTreeNode
      | LegacyRetailWarcraftTalentTreeNode
    )[];
    id: number;
  };
  spellModifierId: number;
};

export interface RetailWarcraftHeroTreeBlueprint {
  id: number;
  name: string;
  icon: string;
}
